export const STORAGE_MULTI_ORDER_ITEMS = "multiOrderItems";
